import React from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import getLocalized from 'utils/get-localized';
import { cutText } from 'utils/cut-text';

export const StyledProgramInfoWrapper = styled.div`
  position: absolute;
  top: ${scaleSize(44)}px;
  display: inline-block;
  box-sizing: border-box;
  width: ${scaleSize(840)}px;
  height: ${scaleSize(100)}px;
  margin-left: ${scaleSize(20)}px;
  text-align: left;
  white-space: normal;
`;

export const StyledChannelTitle = styled.div`
  font-size: ${scaleSize(36)}px;
  line-height: ${scaleSize(60)}px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.activeColor};
`;

export const StyledProgramTitle = styled.div`
  font-size: ${scaleSize(36)}px;
  line-height: ${scaleSize(60)}px;
  color: ${({ theme }) => theme.defaultColor};
`;

export const StyledProgramDescription = styled.div`
  font-size: ${scaleSize(32)}px;
  color: ${({ theme }) => theme.defaultColor};
`;

const MAX_LENGTH = 970;

const ProgramInfo = ({ channel, program }) => {
  if (!program) return null;

  const channelTitle = getLocalized(channel.titles, channel.titles.UA || channel.title);
  const programTitle = getLocalized(program.titles, program.titles.UA || program.title);
  const programDescription = getLocalized(program.descriptions, program.descriptions.UA || program.description);

  if (!programDescription || programDescription === '--') return null;

  return (
    <StyledProgramInfoWrapper>
      <StyledChannelTitle>{channelTitle}</StyledChannelTitle>
      <StyledProgramTitle>{programTitle}</StyledProgramTitle>
      <StyledProgramDescription>{cutText(programDescription, MAX_LENGTH)}</StyledProgramDescription>
    </StyledProgramInfoWrapper>
  );
};

export default ProgramInfo;
